import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default async (form: object): Promise<any> => {
    const url = urlBuilder("/api/mediaemail/sendemail");

    const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: JSON.stringify(form)
    });

    return response.json();
};